import { Component, OnInit } from '@angular/core';

import * as firebase from 'firebase';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-new-users',
  templateUrl: './new-users.component.html',
  styleUrls: ['./new-users.component.css']
})
export class NewUsersComponent implements OnInit {

  month: string = "";
  users: Array<any> = [];

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.month = params['month'];
      if(this.month) {
        this.filter();
      } else {
        this.getUsers();
      }
      
    });

  }

  filter() {
    var monthNum = this.getMonth(this.month);

    var date = new Date();

    date.setMonth(monthNum, 1);
    date.setHours(0, 0, 1);

    var start = date.getTime();

    date.setMonth(monthNum + 1, 0);

    date.setHours(23, 59, 59);

    var end = date.getTime();

    this.getUsers(start, end);
  }

  getUsers(start?, end?) {
    var ref: any = firebase.database().ref('users');

    if (start) {
      ref = ref.orderByChild("createdAt")
        .startAt(start)
        .endAt(end);
    }

    ref.once("value")
      .then(snapshot => {
        var data = snapshot.val();

        if (!data) {
          this.users = [];
          return;
        }

        for (var key in data) {
          var temp = data[key];

          temp.uid = key;

          this.users.push(temp);
        }
      })
      .catch(err => {
        alert(err.message);
        console.log(err);
      })
  }

  getMonth(month) {
    switch (month) {
      case 'Jan':
        return 0;
      case 'Feb':
        return 1;
      case 'Mar':
        return 2;
      case 'Apr':
        return 3;
      case 'May':
        return 4;
      case 'Jun':
        return 5;
      case 'Jul':
        return 6;
      case 'Aug':
        return 7;
      case 'Sep':
        return 8;
      case 'Oct':
        return 9;
      case 'Nov':
        return 10;
      case 'Dec':
        return 11;
      default:
        return -1;
    }
  }
}
